export default {
  path: '/2019XHZW',
  name: 'XHZW2019',
  component: () => import('./Home.vue'),
  meta: {
    title: '携号转网下月实施，要走要留你说了算（附在线调查）',
  },
};
